import dayjs from 'dayjs';
import { IWork } from 'models';

export function getWorkNumber(work?: IWork) {
	const newNumbersDate = dayjs('2026-03-31');
	if(work) {
		const moveDate = dayjs(work.date);
		if(moveDate.isBefore(newNumbersDate)) {
			return `${work?.meta?.work_id}(${work.id})`;
		} else {
			return work?.meta?.work_id;
		}
	} else {
		return '...';
	}
}